/**
 * KBG v2 — Switches: family tabs, spec toggle, audio, quiz
 */
(function () {
  'use strict';

  if (window.__kbgV2SwitchesInit >= 6) return;
  window.__kbgV2SwitchesInit = 6;

  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }
  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* ---- Switch family tabs ---- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-kbg-fam-tab]');
    if (!tab) return;
    var section = tab.closest('[data-kbg-switches]');
    if (!section) return;
    var i = parseInt(tab.getAttribute('data-kbg-fam-tab'), 10);
    qsa(section, '[data-kbg-fam-tab]').forEach(function (t, idx) {
      var selected = idx === i;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.setAttribute('tabindex', selected ? '0' : '-1');
    });
    qsa(section, '.fam-panel').forEach(function (p, idx) {
      var active = idx === i;
      p.setAttribute('data-active', active ? 'true' : 'false');
      if (active) {
        p.removeAttribute('hidden');
        p.removeAttribute('inert');
      } else {
        p.setAttribute('hidden', '');
        p.setAttribute('inert', '');
      }
    });
    stopAllSwitchAudio();
    activeAudio = null;
    activeBtn = null;
    requestAnimationFrame(function () {
      syncCreamyHeight(section);
    });
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-kbg-fam-tab]');
    if (!tab) return;
    var section = tab.closest('[data-kbg-switches]');
    if (!section) return;
    var tabs = qsa(section, '[data-kbg-fam-tab]');
    var current = tabs.indexOf(tab);
    if (current === -1) return;

    var nextIndex = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIndex = (current + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIndex = (current - 1 + tabs.length) % tabs.length;
    } else if (e.key === 'Home') {
      nextIndex = 0;
    } else if (e.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    tabs[nextIndex].click();
    tabs[nextIndex].focus();
  });

  /* ---- Spec toggle ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kbg-toggle-spec]');
    if (!btn) return;
    var section = btn.closest('[data-kbg-switches]');
    var s = btn.nextElementSibling;
    if (!s) return;
    var open = s.getAttribute('data-open') === 'true';
    var showLabel =
      (section && section.getAttribute('data-spec-show')) || 'Show specs';
    var hideLabel =
      (section && section.getAttribute('data-spec-hide')) || 'Hide specs';
    var nextOpen = !open;
    s.setAttribute('data-open', nextOpen ? 'true' : 'false');
    if (nextOpen) s.removeAttribute('hidden');
    else s.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
    btn.textContent = nextOpen ? hideLabel : showLabel;
    if (section) {
      requestAnimationFrame(function () {
        syncCreamyHeight(section);
      });
    }
  });

  /* ---- Audio play (v1-style, audio bank outside hidden panels) ---- */
  var activeAudio = null;
  var activeBtn = null;

  function getPlayLabel(btn) {
    return btn.getAttribute('data-play-label') || '▶ Hear it';
  }

  function getPlayingLabel(btn) {
    return btn.getAttribute('data-playing-label') || '◼ Playing';
  }

  function getPlayAria(btn) {
    return btn.getAttribute('data-play-aria') || getPlayLabel(btn);
  }

  function getStopAria(btn) {
    return btn.getAttribute('data-stop-aria') || getPlayingLabel(btn);
  }

  function resetPlayButton(btn) {
    btn.classList.remove('playing');
    btn.textContent = getPlayLabel(btn);
    btn.setAttribute('aria-label', getPlayAria(btn));
    btn.setAttribute('aria-pressed', 'false');
  }

  function stopAllSwitchAudio(exceptAudio, exceptBtn) {
    qsa(document, '[data-kbg-switches] .sw-audio-bank audio').forEach(function (audio) {
      if (audio === exceptAudio) return;
      audio.pause();
      audio.currentTime = 0;
    });
    qsa(document, '[data-kbg-switches] [data-kbg-play]').forEach(function (btn) {
      if (btn === exceptBtn) return;
      resetPlayButton(btn);
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-kbg-play]');
      if (!btn || btn.classList.contains('disabled')) return;

      var section = btn.closest('[data-kbg-switches]');
      if (!section) return;

      var audioId = btn.getAttribute('data-audio-id');
      if (!audioId) return;

      var audio = document.getElementById(audioId);
      if (!audio) return;

      e.stopImmediatePropagation();

      if (activeAudio && activeAudio !== audio) {
        activeAudio.pause();
        activeAudio.currentTime = 0;
      }
      if (activeBtn && activeBtn !== btn) {
        resetPlayButton(activeBtn);
      }

      if (activeAudio === audio && activeBtn === btn && !audio.paused) {
        audio.pause();
        audio.currentTime = 0;
        resetPlayButton(btn);
        activeAudio = null;
        activeBtn = null;
        return;
      }

      stopAllSwitchAudio(audio, btn);

      audio.muted = false;
      audio.volume = 1;

      function startPlayback() {
        audio
          .play()
          .then(function () {
            activeAudio = audio;
            activeBtn = btn;
            btn.classList.add('playing');
            btn.textContent = getPlayingLabel(btn);
            btn.setAttribute('aria-label', getStopAria(btn));
            btn.setAttribute('aria-pressed', 'true');
          })
          .catch(function () {
            resetPlayButton(btn);
            activeAudio = null;
            activeBtn = null;
          });
      }

      audio.onended = function () {
        resetPlayButton(btn);
        if (activeBtn === btn) activeBtn = null;
        if (activeAudio === audio) activeAudio = null;
      };

      if (audio.readyState >= 2) {
        startPlayback();
      } else {
        audio.addEventListener(
          'canplay',
          function onCanPlay() {
            audio.removeEventListener('canplay', onCanPlay);
            startPlayback();
          },
          { once: true }
        );
        audio.load();
      }
    },
    true
  );

  /* ---- Switch quiz (18-combo lookup, matches switch-picker preview) ---- */
  var SWITCH_WHY = {
    Cream:
      'Smooth, buttery linear \u2014 a comfortable all-rounder for both gaming and long typing.',
    'Cream / Silent':
      'Smooth linear comfort \u2014 pick Silent if you need near-total quiet for calls and shared rooms.',
    'Cream / Magnetic':
      'Smooth linear feel \u2014 or step up to magnetic Hall-effect for adjustable actuation and rapid trigger.',
    Beige: 'A defined tactile bump for precise, satisfying typing, with a rich, deep sound.',
    'Beige / Magnetic':
      'Tactile feedback for typing \u2014 or magnetic Hall-effect when you want the fastest gaming input.',
    Snowfall:
      'A tactile switch with a crisp, clicky sound \u2014 you get the click you\u2019re after over a smoother, bumpy feel.',
  };

  var SWITCH_COMBO = {
    shared_gaming_smooth: { sw: 'Cream', top: ['R65', 'R75', 'S98'] },
    shared_gaming_bump: { sw: 'Beige / Magnetic', top: ['L75', 'C84', 'C87'] },
    shared_gaming_click: { sw: 'Snowfall', top: ['RK61', 'RK84', 'RK920'] },
    shared_typing_smooth: { sw: 'Cream / Silent', top: ['L75', 'S98', 'R99'] },
    shared_typing_bump: { sw: 'Beige', top: ['L75', 'L98', 'F99'] },
    shared_typing_click: { sw: 'Snowfall', top: ['RK68', 'RK84', 'RK920'] },
    shared_both_smooth: { sw: 'Cream / Silent', top: ['R75', 'S98', 'R99'] },
    shared_both_bump: { sw: 'Beige', top: ['L75', 'S98', 'L98'] },
    shared_both_click: { sw: 'Snowfall', top: ['RK61', 'RK68', 'RK84'] },
    solo_gaming_smooth: { sw: 'Cream / Magnetic', top: ['C87', 'R75', 'S98'] },
    solo_gaming_bump: { sw: 'Beige / Magnetic', top: ['L75', 'C96', 'C87'] },
    solo_gaming_click: { sw: 'Snowfall', top: ['RK61', 'RK84', 'RK920'] },
    solo_typing_smooth: { sw: 'Cream', top: ['S104', 'R99', 'R75'] },
    solo_typing_bump: { sw: 'Beige', top: ['L75', 'L98', 'F99'] },
    solo_typing_click: { sw: 'Snowfall', top: ['RK68', 'RK84', 'RK920'] },
    solo_both_smooth: { sw: 'Cream', top: ['R75', 'S98', 'R99'] },
    solo_both_bump: { sw: 'Beige', top: ['L75', 'S98', 'F99'] },
    solo_both_click: { sw: 'Snowfall', top: ['RK84', 'R75', 'RK920'] },
  };

  var SWITCH_BOARDS = {
    R65: { label: 'R65', href: '/products/r65-65-wireless-gaming-keyboard' },
    R75: { label: 'R75', href: '/products/r75-75-wireless-gaming-keyboard' },
    R99: { label: 'R99', href: '/products/r99-wireless-mechanical-keyboard' },
    S98: { label: 'S98', href: '/products/s98-wireless-mechanical-keyboard' },
    S104: { label: 'S104', href: '/products/s104-wireless-full-size-mechanical-keyboard' },
    L75: { label: 'L75', href: '/products/l75-75-wireless-mechanical-keyboard' },
    L98: { label: 'L98', href: '/products/l98-96-wireless-mechanical-keyboard' },
    F99: { label: 'F99', href: '/products/f99-96-wireless-mechanical-keyboard' },
    RK61: { label: 'RK61', href: '/products/rk61-60-color-block-edition' },
    RK68: { label: 'RK68', href: '/products/rk68-65-wireless-mechanical-keyboard' },
    RK84: { label: 'RK84', href: '/products/rk84-limited-edition' },
    RK920: { label: 'RK920', href: '/products/rk920-color-block-edition' },
    C84: { label: 'C84 HE', href: '/products/c84-magnetic-keyboard' },
    C87: { label: 'C87 HE', href: '/products/c87-80-tkl-magnetic-hall-effect-keyboard' },
    C96: { label: 'C96 HE', href: '/products/c96-96-hall-effect-magnetic-switch-keyboard' },
  };

  function initQuizBoards(section) {
    var source = section.querySelector('[data-quiz-boards-source]');
    var target = section.querySelector('[data-quiz-boards]');
    if (!source || !target || target.getAttribute('data-ready') === 'true') return;
    try {
      target.innerHTML = JSON.parse(source.textContent);
      target.setAttribute('data-ready', 'true');
    } catch (err) {
      /* ignore invalid HTML JSON */
    }
  }

  function selectedQuizVal(section, q) {
    var btn = qs(section, '[data-q="' + q + '"] .opt[aria-checked="true"]');
    return btn ? btn.getAttribute('data-val') : null;
  }

  function getQuizBoard(section, key) {
    var fallback = SWITCH_BOARDS[key];
    var link = qs(section, '[data-quiz-board="' + key + '"]');
    if (!link && !fallback) return null;
    return {
      label:
        (link && (link.getAttribute('data-label') || link.textContent.trim())) ||
        (fallback && fallback.label) ||
        key,
      href: (link && link.getAttribute('href')) || (fallback && fallback.href) || '#',
    };
  }

  function renderQuizResult(section, options) {
    initQuizBoards(section);
    var room = selectedQuizVal(section, 'room');
    var use = selectedQuizVal(section, 'use');
    var feel = selectedQuizVal(section, 'feel');
    if (!room || !use || !feel) return;

    var combo = SWITCH_COMBO[room + '_' + use + '_' + feel];
    if (!combo) return;

    var rSwitch = qs(section, '[data-r-switch]');
    var rWhy = qs(section, '[data-r-why]');
    var boardsEl = qs(section, '[data-r-boards]');
    var result = qs(section, '[data-kbg-result]');
    if (!result) return;

    if (rSwitch) {
      var switchPrefix =
        section.getAttribute('data-result-switch-prefix') || 'Your switch: ';
      rSwitch.textContent = switchPrefix + combo.sw;
    }
    if (rWhy) rWhy.textContent = SWITCH_WHY[combo.sw] || '';

    var links = combo.top
      .map(function (key) {
        var board = getQuizBoard(section, key);
        if (!board) return '';
        return (
          '<a class="btn btn-primary btn-sm" href="' +
          board.href +
          '">' +
          board.label +
          '</a>'
        );
      })
      .join('');

    if (boardsEl) {
      var boardsLabel =
        section.getAttribute('data-result-boards-label') || 'Top 3 for you \u2192';
      boardsEl.innerHTML =
        '<span class="rboards-label">' + boardsLabel + '</span>' + links;
    }
    result.setAttribute('data-show', 'true');
    if (options && options.scroll) {
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kbg-quiz-opt]');
    if (!btn) return;
    var section = btn.closest('[data-kbg-switches]');
    if (!section) return;
    btn.parentElement.querySelectorAll('.opt').forEach(function (o) {
      o.setAttribute('aria-checked', 'false');
    });
    btn.setAttribute('aria-checked', 'true');
    renderQuizResult(section, { scroll: true });
  });

  /* ---- Creamy sidebar: match first-row card height ---- */
  function syncCreamyHeight(section) {
    var creamy = section.querySelector('.creamy');
    if (!creamy) return;

    if (window.matchMedia('(max-width: 1080px)').matches) {
      creamy.style.height = '';
      creamy.style.minHeight = '';
      return;
    }

    var panel = section.querySelector('.fam-panel[data-active="true"]');
    var first = panel && panel.querySelector('.sw');
    if (!first) {
      creamy.style.height = '';
      creamy.style.minHeight = '';
      return;
    }

    var next = Math.round(first.getBoundingClientRect().height) + 'px';
    creamy.style.height = '';
    if (creamy.style.minHeight !== next) {
      creamy.style.minHeight = next;
    }
  }

  function observeCreamy(section) {
    if (section.__kbgCreamyObs) return;
    if (typeof ResizeObserver === 'undefined') return;

    var area = section.querySelector('.sw-area');
    if (!area) return;

    var ro = new ResizeObserver(function () {
      syncCreamyHeight(section);
    });
    section.__kbgCreamyObs = ro;
    ro.observe(area);
  }

  function initSwitchSection(section) {
    observeCreamy(section);
    syncCreamyHeight(section);
    renderQuizResult(section, { scroll: false });
  }

  function initSwitchSections() {
    qsa(document, '[data-kbg-switches]').forEach(initSwitchSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwitchSections);
  } else {
    initSwitchSections();
  }

  window.addEventListener('resize', function () {
    qsa(document, '[data-kbg-switches]').forEach(syncCreamyHeight);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-kbg-switches]');
    if (!section) return;
    initSwitchSection(section);
  });
})();
